import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IItemCardProps } from 'models/itemcard';
import { IShoppingBasketItem } from 'models/cart/shoppingbasketitem';
import { formatCurrency, setProductPictureUrl, formatInteger } from 'helpers/common';
import { INodeData } from 'models/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IShoppingBasketItem;
	t?: (key: string, options?: any) => string;
	currencyKey?: number;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CheckoutProductItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
		this.handleDeleteFromCartClick = this.handleDeleteFromCartClick.bind(this);
	}

	private handleDeleteFromCartClick() {
		if (this.props.deleteItem !== undefined) {
			this.props.deleteItem('', JSON.parse(this.props.item.entityId).id);
		}
	}

	private goToCard(e: any, id, type, target) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(id, type, target);
		}
	}

	public render() {
		const { t, currencyKey } = this.props;
		const { picture, name, qty, attributes, sellingPrice, shopName, shopId } = this.props.item;

		const sizeText = `${t('BSPortal_Common_Size')}: ${t(`DV_Sizes_${attributes.SizeKey}`)}`;
		const colorText = `${t('BSPortal_Common_Color')}: ${t(`DV_Colors_${attributes.ColorKey}`)}`;
		const qtyText = `${t('BSPortal_Common_Qty')}: ${formatInteger(qty)}`;

		let sizeColorQtyElement: JSX.Element = null;
		if (attributes.SizeKey && !attributes.ColorKey) {
			sizeColorQtyElement = <span>{`${sizeText} - ${qtyText}`}</span>;
		} else if (!attributes.SizeKey && attributes.ColorKey) {
			sizeColorQtyElement = <span>{`${colorText} - ${qtyText}`}</span>;
		} else if (!attributes.SizeKey && !attributes.ColorKey) {
			sizeColorQtyElement = <span>{qtyText}</span>;
		} else {
			sizeColorQtyElement = <span>{`${sizeText} - ${colorText} - ${qtyText}`}</span>;
		}

		const entityIdObj: INodeData = JSON.parse(this.props.item.entityId);

		return (
			<div className="checkoutProductItemCard">
				<div className="imageWrapper">
					<a
						href="#"
						onClick={(e) => {
							this.goToCard(e, entityIdObj.id, entityIdObj.type, '_blank');
						}}
						className="imageHolder"
					>
						<img {...setProductPictureUrl(picture, true)} />
					</a>
				</div>
				<div className="rightSideTextWrapper">
					<div className="title">
						<a
							href="#"
							onClick={(e) => {
								this.goToCard(e, entityIdObj.id, entityIdObj.type, '_blank');
							}}
						>
							<div className="productName" title={name}>
								{name}
							</div>
						</a>
					</div>
					<div className="shopWrapper">
						<a
							href="#"
							onClick={(e) => {
								this.goToCard(e, shopId, c.NODE_TYPE_SHOP, '_blank');
							}}
						>
							<div className="productName" title={shopName}>
								{shopName}
							</div>
						</a>
					</div>
					<div className="sizeQty">{sizeColorQtyElement}</div>
					<div className="priceProduct">{formatCurrency(currencyKey, sellingPrice)}</div>
				</div>
				{this.props.deleteItem ? (
					<div>
						<button className="btnDeleteDropdown" type="button" onClick={this.handleDeleteFromCartClick}>
							<span className="removeBTMdropdownCheckout">Remove</span>
						</button>
					</div>
				) : null}
			</div>
		);
	}
}
export { CheckoutProductItemCard };
